import script from "./ClassicSetPasswordStep.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassicSetPasswordStep.vue?vue&type=script&setup=true&lang=js"

import "./ClassicSetPasswordStep.vue?vue&type=style&index=0&id=47d6fa0d&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/actions-runner/_work/keepyoursight/keepyoursight/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47d6fa0d"]])

export default __exports__